export default __webpack_public_path__ + "static/media/Kismat R. Kathrani.0cb2d7d7.jpg";